import { render, staticRenderFns } from "./QuizStudentQuestion.vue?vue&type=template&id=6bd2a2bb&"
import script from "./QuizStudentQuestion.vue?vue&type=script&lang=js&"
export * from "./QuizStudentQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuizStudentQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports